import { HandleExeption, RaiseSomethingWentWrong } from './../Redux/HandleExeption';

export default class HttpService {

    logurl_token_name = process.env.REACT_APP_BACKEND_TOKEN_NAME;

    url = process.env.REACT_APP_BACKEND_HOST_ENDPOINT;

    logurl = process.env.REACT_APP_LOGIN_ROUTE;

    postData = async (payload, uri, tokenId = "", signal) => {

        const token = await localStorage.getItem(tokenId);

        const requestOptions = this.postRequestOptions(token, payload, signal);
        const isLogoutRoute = uri === process.env.REACT_APP_BACKEND_LOGOUT_ROUTE || uri === 'logout';

        return fetch(this.url + "/" + uri, requestOptions)
            .then(response => response.json())
            .then(data => { HandleExeption(data, isLogoutRoute); return data })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return {
                        data: [],
                        success: false,
                        error_type: error.name,
                        message: "Request Aborted Successfully",
                    };
                } else {
                    if (!isLogoutRoute) {
                        RaiseSomethingWentWrong();
                    }
                    return {
                        data: [],
                        success: false,
                        message: error.message,
                        error_type: error.name
                    };
                }
            });
    }

    getData = async (uri, tokenId = "", signal = '') => {

        const token = tokenId ? await localStorage.getItem(tokenId) : null;
        if (tokenId && !token) {
            return {
                data: [],
                success: false,
                exception_type: 'unthenticated',
                message: "No authorization token available"
            };
        }

        const requestOptions = this.getRequestOptions(token, signal);

        return fetch(this.url + "/" + uri, requestOptions)
            .then(response => response.json())
            .then(data => { HandleExeption(data); return data })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return {
                        data: [],
                        success: false,
                        error_type: error.name,
                        message: "Request Aborted Successfully",
                    };
                } else {
                    RaiseSomethingWentWrong();
                    return {
                        data: [],
                        success: false,
                        message: error.message,
                        error_type: error.name
                    };
                }
            });
    }

    getRequestOptions = (token, signal) => {
        const headers = { 'Content-type': 'application/json' };
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
        let requestOptions = {
            method: 'GET',
            headers,
        };
        if (signal) {
            requestOptions['signal'] = signal;
        }
        return requestOptions;
    }

    putData = async (payload, uri, tokenId = "", signal = '') => {
        const token = await localStorage.getItem(tokenId);
        const requestOptions = this.putRequestOptions(token, payload, signal);
        return fetch(this.url + "/" + uri, requestOptions)
            .then(response => response.json())
            .then(data => { HandleExeption(data); return data; })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return { data: [], success: false, error_type: error.name, message: "Request Aborted Successfully" };
                }
                RaiseSomethingWentWrong();
                return { data: [], success: false, message: error.message, error_type: error.name };
            });
    }

    putRequestOptions = (token, item, signal = '') => {
        const headers = { 'Content-type': 'application/json' };
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
        let requestOptions = {
            method: 'PUT',
            headers,
            body: JSON.stringify(item)
        };
        if (signal) {
            requestOptions['signal'] = signal;
        }
        return requestOptions;
    }

    postRequestOptions = (token, item, signal = '') => {
        const headers = { 'Content-type': 'application/json' };
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
        let requestOptions = {
            method: 'POST',
            headers,
            body: JSON.stringify(item)
        };
        if (signal) {
            requestOptions['signal'] = signal;
        }
        return requestOptions;
    }

}